import styled from "styled-components";
import { ReservationInfoWrapper } from "../reservationInfo/styles";

export const GuestDataWrapper = styled(ReservationInfoWrapper)``;

export const PhoneInputWrapper = styled.div``;

export const PhoneHelperText = styled.div`
  font-size: 12px;
  color: #6B7280;
  margin-top: 4px;
  font-family: 'Tajawal', sans-serif;
  font-weight: 400;
  line-height: 1.4;
`;
